import "./LockingPeriodRow.scss"
import React from "react"
import LockPeriodText from "./LockPeriodText"
import { BoostPoolInfo } from "src/constants/boostPools"
import { useTranslation } from "react-i18next"
import { useVaultsApr } from "src/pages/Stake/hooks/useVaultsApr"
import { Box } from "@mui/material"
import Text from "src/components/Text"
import { formatNumber } from "src/utils/parseStringToBigNumber"
import QuestionHelper from "src/components/QuestionHelper"
import { ChevronRight } from "@mui/icons-material"
import GradientWrapper from "src/components/GradientWrapper"
import { useIsMobile } from "src/hooks/useIsMobile"

interface LockingPeriodBoxProps extends BoostPoolInfo {
  onSelect: () => void
}

const LockingPeriodBox = ({
  pid,
  imgSrc,
  multiplier,
  lockPeriod,
  onSelect,
}: LockingPeriodBoxProps) => {
  const { t } = useTranslation()
  const vaultsApr = useVaultsApr()
  const isMobile = useIsMobile()
  const poolApr = vaultsApr.find((x) => x.poolId === pid)?.apr || "0"

  return (
    <GradientWrapper
      borderRadius="10px"
      background="#000000"
      mb={2}
      className="locking-period-row"
      onClick={onSelect}
    >
      <Box
        display={isMobile ? "block" : "flex"}
        justifyContent="space-between"
        p={isMobile ? 1 : 3}
      >
        <Box display="flex" alignItems="center" mb={isMobile ? 1 : 0}>
          <img src={imgSrc} />
          <LockPeriodText pid={pid} lockPeriod={lockPeriod} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          ml={1}
          justifyContent="space-between"
        >
          <Box>
            <Box display="flex" alignItems="center" mb={1}>
              <Text size="small">{t("Multiplier")}</Text>
              <QuestionHelper
                text="This represents the multiplier factor applied to your staking amount. A 6x multiplier for example will yield 6 times the rewards and benefits compared to 1x."
                ml="6px"
              />
            </Box>
            <Text>{multiplier / 100}x</Text>
          </Box>
          <Box
            style={{
              marginLeft: isMobile ? "20px" : "40px",
              width: isMobile ? "100px" : "120px",
            }}
          >
            <Box display="flex" alignItems="center" mb={1}>
              <Text size="small">{t("APR")}</Text>
              <QuestionHelper
                text="APR adjusts based on the price of FER and number of users staked. While the APR will change, the multiplier factor between the vaults will stay constant."
                ml="6px"
              />
            </Box>
            <Text width="128px" style={{ wordBreak: "break-word" }}>
              {formatNumber(poolApr, 2, 2)}%
            </Text>
          </Box>
          <ChevronRight />
        </Box>
      </Box>
    </GradientWrapper>
  )
}

export default LockingPeriodBox
